                                                  
import NavigationBar from "../components/NavigationBar";
import {connect} from "react-redux";

                                      

function mapStateToProps(state                  , props                             ) {
	return {
		cartItemCount: state.cart.items ? state.cart.items.length : 0,
		cartDisabled: state.cart.cartDisabled,
	};
}

// function mapDispatchToProps(dispatch: Dispatch, ownProps: NavigationBarContainerProps) {
//
// }

export default connect(mapStateToProps, null)(NavigationBar);
